
<div class="labels-table">
  <div class="labels-table-container bg-white ob-scroll">
    <div class="label">{{ labelsHeader }}</div>

    <div class="font-weight-bold boards-labels-row">
      <div class="mt-2 mb-1">Category</div>
      <div class="mt-2 mb-1">Name</div>
      <div class="mt-2 mb-1">Icon</div>
      <div class="mt-2 mb-1">Color</div>
      <div class="mt-2 mb-1"></div>
      <div class="mt-2 mb-1"></div>
      <div class="mt-2 mb-1"></div>
    </div>

    <div v-for="label in labels" :key="label.id">
      <div class="boards-labels-row">
        <input
          :disabled="isArchivedLabels"
          class="form-control form-control-sm"
          placeholder="Enter a category for this label"
          v-model="label.category"
          type="text"
          @input="markAsDirty()"
        />
        <input
          :disabled="isArchivedLabels"
          class="form-control form-control-sm"
          placeholder="Enter a name for the label"
          v-model="label.title"
          type="text"
          @input="markAsDirty()"
        />

        <div>
          <v-select
            :disabled="isArchivedLabels"
            :options="labelsIcons"
            :reduce="(icon) => icon.key"
            :clearable="true"
            placeholder="Select a label icon"
            v-model="label.icon"
            :append-to-body="true"
            @input="markAsDirty()"
          >
            <template #selected-option="{ key, label }">
              <div class="d-flex align-items-center">
                <div>
                  <i :class="key"></i>
                </div>
                <div class="ml-2">{{ label }}</div>
              </div>
            </template>

            <template #option="{ key, label }">
              <div class="d-flex align-items-center">
                <div>
                  <i :class="key"></i>
                </div>
                <div class="ml-2">{{ label }}</div>
              </div>
            </template>
          </v-select>
        </div>
        <v-swatches
          :disabled="isArchivedLabels"
          :row-length="swatches.length"
          popover-x="left"
          v-model="label.color"
          :swatches="swatches"
          @input="markAsDirty()"
        />

        <div
          v-if="!isArchivedLabels"
          :class="{ disabled: label.isUsed }"
          class="delete-btn btn badgebutton danger active"
          v-b-tooltip:hover
          :title="label.isUsed ? 'This label can not be deleted because it was already used.' : ''"
          v-on:click.stop="deleteLabel(label)"
        >
          <i class="far fa-trash"></i>
        </div>

        <div
          v-if="!label.isDeleted && label.isUsed"
          class="btn badgebutton orange active"
          v-b-tooltip:hover
          title="Archive"
          v-on:click.stop="archiveLabelFunc(label)"
        >
          <i class="far fa-archive"></i>
        </div>

        <div
          v-if="label.isDeleted && label.isArchived"
          class="btn badgebutton primary active"
          v-b-tooltip:hover
          title="Reactivate"
          v-on:click.stop="reactivateLabel(label)"
        >
          <i class="fa fa-folder-open"></i>
        </div>
      </div>
    </div>

    <div v-if="!labels || !labels.length" class="p-2 text-center font-weight-bold" style="color: #aaa; font-size: 2.5rem">
      <i class="far fa-shapes"></i>
      <br />
      No Labels available
    </div>
  </div>
</div>
